import { Loading, Notification } from "#/atoms";
import { useCallback, useEffect } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

import { CredentialResponse } from '@react-oauth/google';
import { Login } from "#/pages";
import { useApi } from "@/api";

interface LocationState {
  from: {
    pathname: string;
  };
}

const LoginView = () => {
  const navigate = useNavigate();
   const location = useLocation();
  const { errorMessage, loading, session } = useApi()

  const { token } = useParams<'token'>();
  const { tokenid } = useParams<'tokenid'>();
  const [searchParams] = useSearchParams();
  const reset = searchParams.get('reset');
  
  const from = (location.state as LocationState)?.from?.pathname || "/";

  useEffect(() => {
    const logoutIfNeeded = async () => {
      
      if (reset) {
        await session.logout();
      } 
      else {
        if (session.user) {
          if (session.user.admin) {
            
            navigate(from);
          }
          else {
           
            navigate('/')
          }
        }
      }
    }
    logoutIfNeeded();


  }, [reset, session])

  useEffect(() => {
    if (token && tokenid) {
      session.activate(token, tokenid);
    }
  }, [])

  const handleSubmit = useCallback((user: string, password: string, rememberMe: boolean) => {
    session.login(user, password, rememberMe).then(() => {
      navigate('/');
    });
  }, []);

  const handlePasswordReset = useCallback((email: string) => {
    session.resetPassword(email);
  }, []);

  const handleSignup = useCallback(() => {
    navigate('/register', { replace: true });
  }, []);

  const handleGoogleloginSuccess = useCallback((response: CredentialResponse) => {
    const idToken = response.credential;
      
    if (idToken) {
      session.loginGoogle(idToken);
    }
  }, []);

  return (
    <>
      {loading && <Loading />}
      {errorMessage && <Notification>{errorMessage}</Notification>}
      <Login onSubmit={handleSubmit} onSignup={handleSignup} onGoogleSuccess={handleGoogleloginSuccess} onPasswordReset={handlePasswordReset} />
    </>
  );
}

export default LoginView;